import * as React from "react"
import Logo from "../components/logo" 

class Header extends React.Component {
  componentDidMount() {
    this.menuEventListener();  
    this.linkEventListener();  
  }

  menuEventListener() {
    var menuIcon = document.querySelector('.menu--icon');
    var closeIcon = document.querySelector('.close--icon');
    var overlayMenu = document.querySelector('.overlay--menu');
    var bottomBar = document.querySelector('.bottom-menu--fixed');
    var pageNavigation = document.querySelector('.page--navigation');
    
    menuIcon.addEventListener("click", function(e) {
      overlayMenu.classList.add('is-active');
      bottomBar.classList.add('is-active');
      pageNavigation.classList.add('is-hidden');
    });
    closeIcon.addEventListener("click", function(e) {
      overlayMenu.classList.remove('is-active');
      bottomBar.classList.add('is-active');
      pageNavigation.classList.remove('is-hidden');  
    });
  }  

  linkEventListener() {
    var allLinks = document.querySelectorAll('.internal--link');
    for (var a = 0; a < allLinks.length; a++) {
      allLinks[a].addEventListener("click", function(e) { 
        document.querySelector('.floating--cursor').classList.add('transition-out'); 
        document.querySelector('.preloader').classList.add('fade-in');
        document.querySelector('.bottom-menu--fixed').classList.add('is-transitioning');  
        document.querySelector('.loader-icon').classList.add('is-rotating');  
      });  
    }  
  } 

  render() {
    return (
    <header className="masthead">
      <div className="inner flex align-center"> 
        <div className="return--container">
          <div className="menu-icon">
            <div className="menu-wrapper menu--icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>  
        </div>
        <div className="mobile--logo m-show">
          <a href="/" className="internal--link">
            <Logo />
          </a>
        </div>
        <div className="page-title mla mra h4 m-hide">
          {this.props.pageTitle}
        </div> 
        <div className="booking--container m-hide"> 
          <a className="strong underline-link internal--link" href="/contact">Make a booking</a> 
        </div>
      </div>
    </header>
    )
  }
} 

export default Header

